<!--
  Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<div class="input-group">
  @if (label) {
    <label class="font-weight-bold text-right">{{ (ngRequired ? "*" : "") + label }}: </label>
  }
  <span style="display: flex; align-items: center; height: 100%; gap: 0.25rem;">
    <img [src]="ngSelectedUser.profilePicUrl" alt="selected profile picture"
      width="28" height="28"
      style="border-radius: 15% 0% 0% 15%; object-fit: cover;"
      (load)="toggleImageFallback($event, false)"
      (error)="toggleImageFallback($event, true)"/>
      <span class="profile-image-fallback-icon" style='display: none; color: lightgrey; padding-left: 8px'>
        @if (readonly) {
          <i class='pi pi-user' style='font-size: 1.5rem'></i>
        }
        @if (!readonly) {
          <i class='pi pi-user-edit' style='font-size: 1.5rem'></i>
        }
      </span>
    </span>
    <p-autoComplete #userAutoSearch [(ngModel)]="ngSelectedUser"
      [suggestions]="filteredNames" optionLabel="fullName" [minLength]="5" [delay]="700"
      [showEmptyMessage]="false"
      (completeMethod)="autoSearchUserSimplified($event)" [readonly]="readonly"
      (onSelect)="autoSelectUserSearchResults(ngSelectedUser)">
      <ng-template let-user pTemplate="item">
        <div class="flex items-center gap-2">
          <span>
            <img [src]="user.profilePicUrl" alt="profile picture" width="24" height="24" style="border-radius: 50%; object-fit: cover;"
              (error)="toggleImageFallback($event, true)"/>
            <span class="profile-image-fallback-icon" style='display: none; color: lightgrey;'><i class='pi pi-user'></i></span>
          </span>
          <div>{{ user.fullName }}</div>
        </div>
        </ng-template>
      </p-autoComplete>
      @if (showMeButton && !readonly) {
        <p-button label=" Me" (click)="autoSelectUserSearchResults(user)" class="gm-btn-primary">
          <span>
            <img [src]="user.profilePicUrl" style="border-radius: 50%; object-fit: cover;" width="24" height="24" alt="self profile picture"
              (error)="toggleImageFallback($event, true)"/>
            <span class="profile-image-fallback-icon" style='display: none; color: lightgrey;'><i class='pi pi-user'></i></span>
          </span>
        </p-button>
}
</div>
